import { request } from './request';

export const postFetch = async <T>(
	token: string | null | undefined,
	url: string,
	body: Record<string, unknown>
): Promise<T> => request<T>(url, { method: 'POST', token, body });
